jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});


window.onscroll = function () { //myFunction() 
};
var header = document.getElementById("header");
if (header != null) {
    var sticky = header.offsetTop;
}
function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("fixed");

    } else {
        header.classList.remove("fixed");
    }
}


/********************** Mobile menu ********************** */
jQuery(document).on("click", ".navbar-toggler,.close-menu", function (e) {
    jQuery(jQuery(this).attr('data-target')).toggleClass("show");
});


/**********************Tab And Accordian********************** */

// Loop through each tab container to set up independent tabs
$('.tab-container').each(function () {
    const $container = $(this);
    const $tabButtons = $container.find('.tab-button');
    const $tabContentItems = $container.find('.tab-content-item');

    // Set up click event for each button within this container
    $tabButtons.on('click', function () {
        const $button = $(this);
        console.log($button);
        const target = $button.data('tab');
        console.log(target);

        // Remove active class from all buttons and add to clicked button
        $tabButtons.removeClass('active');
        $button.addClass('active');

        if (target != "all") {
            // Add fade effect to content items
            $tabContentItems.filter(':visible').fadeOut(200, function () {
                $tabContentItems.addClass('hidden');
                $tabContentItems.filter(`[data-content="${target}"]`).removeClass('hidden').fadeIn(200);
            });
        } else {
            $tabContentItems.removeClass('hidden').fadeIn(200);
        }
    });
});
$('.accordion-group').each(function () {
    const $accordionGroup = $(this);

    // Toggle functionality for each accordion item
    $accordionGroup.find('.accordion-toggle').click(function () {
        // Close other items in the current group and reset icons to "+"
        $accordionGroup.find('.accordion-content').not($(this).next()).slideUp();
        $accordionGroup.find('.accordion-item').removeClass('accordion-active');
        $accordionGroup.find('.accordion-icon').not($(this).find('.accordion-icon')).text('+');
        $(this).parents('.accordion-item').addClass('accordion-active');

        // Toggle current item and icon
        $(this).next().slideToggle();
        const icon = $(this).find('.accordion-icon');
        icon.text(icon.text() === '+' ? '-' : '+');
    });
});

function lazyloader() {
    const lazyContent = new LazyLoad({
        elements_selector: ".lazy"
    });

    const lazyBackground = new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}


$(document).ready(function () {
    lazyloader();

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
        $('.header-navigation').toggleClass('open-menu');
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
        $('.header-navigation').removeClass('open-menu');
    });


    /**********************footer menu ********************** */

    jQuery(document).on("click", ".menu-collapse-container .menu-collapse-title", function (e) {
        jQuery(this).parents(".menu-collapse-container").find(".menu-collapse-wrap").slideToggle("slow");
    });

    $('.promotions-slider').slick({
        slidesToShow: 3,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        variableWidth: true,
        nextArrow: $('.slick-promotions-next'),
        prevArrow: $('.slick-promotions-prev'),
    });

    $('.cta-slider').slick({
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });


    $('.services-slider').each(function () {
        var $slider = $(this);
        var $wrap   = $slider.closest('.jb-services-slider-wrap');
        $slider.slick({
            slidesToShow: 3,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            dots: true,
            variableWidth: true,
            nextArrow: $wrap.length ? $wrap.find('.service-next') : $('.service-next'),
            prevArrow: $wrap.length ? $wrap.find('.service-prev') : $('.service-prev'),
            responsive: [
                { breakpoint: 768, settings: { slidesToShow: 1 } },
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
            ],
        });
    });

    $('.process-slider').each(function () {
        var $slider   = $(this);
        var $section  = $slider.closest('.jb-process-block');
        var $dotsWrap = $section.find('.jb-process-dots-wrap');
        var initOpts = {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            speed: 500,
            cssEase: 'cubic-bezier(0.32, 0.72, 0, 1)',
            infinite: false,
            focusOnSelect: false,
            swipeToSlide: true,
            dots: true,
            variableWidth: true,
            initialSlide: 0,
            nextArrow: $section.length ? $section.find('.process-next') : $('.process-next'),
            prevArrow: $section.length ? $section.find('.process-prev') : $('.process-prev'),
            responsive: [
                { breakpoint: 640,  settings: { slidesToShow: 1, variableWidth: false } },
                { breakpoint: 1024, settings: { slidesToShow: 2, variableWidth: false } },
            ],
        };
        if ($dotsWrap.length) { initOpts.appendDots = $dotsWrap; }
        $slider.slick(initOpts);
    });
    $('.logos-slider').slick({
        slidesToShow: 2,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4000,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        variableWidth: true,
        touchMove: false,
        draggable: false,
        swipe: false,
        touchThreshold: 10,
        touchThreshold: 10,
    });

    $('.alphabet-filter button').on('click', function () {
        const $button = $(this);
        const char = $button.data('char');
        if (char == 'All') {
            $('.area-items').removeClass('hidden');
        } else {
            $('.alphabet-filter button').removeClass('active');
            $button.addClass('active');
            $('.area-items').addClass('hidden');
            $('.area-items').filter(`[data-char="${char}"]`).removeClass('hidden');
            $('.category-filter button').removeClass('active');
            $('.show-all-btn').addClass('active');

            if ($('.area-items').filter(`[data-char="${char}"]`).length === 0) {
                $('.noresult').show();
            } else {
                $('.noresult').hide();
            }
        }
    });

    $('#blog-filter').on('change', function () {
        var filter = $(this).val();

        var posts = $('#blog-list .blog-post');

        if (filter == 'popular') {
            posts.sort(function (a, b) {
                var aPopularity = $(a).data('popularity');
                var bPopularity = $(b).data('popularity');
                return bPopularity - aPopularity;
            });
        } else if (filter == 'newest') {
            posts.sort(function (a, b) {
                var aDate = $(a).data('date');
                var bDate = $(b).data('date');
                return new Date(bDate) - new Date(aDate);
            });
        } else if (filter == 'oldest') {
            posts.sort(function (a, b) {
                var aDate = $(a).data('date');
                var bDate = $(b).data('date');
                return new Date(aDate) - new Date(bDate);
            });
        }

        // Append the sorted posts back to the container
        $('#blog-list').html(posts);
    });
});